import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { components } from 'react-select'

import colors from 'components/utils/colors'
import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const StyledWrapper = styled(InnerComponent).attrs({ Component: components.ValueContainer })`
  &.react-select__value-container {
    padding: 0;
    line-height: 16px;
    cursor: text;
    flex-wrap: nowrap;
    white-space: nowrap;

    /* hide some items in the middle when we show "and n others" */
    ${props => props.showOtherItemsStub && css`
      & > *:nth-child(n+${props.selectProps.maxDisplaySelectedItems + 1}):nth-last-child(n+3) {
        display: none;
      }
    `}

    ${props => props.isMulti && !props.showOtherItemsStub && css`
      & > *:nth-child(${props.selectProps.value.length}) {
        margin-right: 0;
      }
    `}
  }

  .react-select__input-container {
    order: 2;
    margin: 0;
    padding: 0;
    .react-select__input {
      margin: 0;
      height: 16px;
    }
  }
`

const OtherItems = styled.div`
  order: 1;
  font-size: 12px;
  font-weight: 600;
  color: ${colors.secondary20};
  padding: 0 3px 0 1px;
  white-space: nowrap;
`

const ValueContainer = ({ children, ...props }) => {
  const { t } = useTranslation()
  const { isMulti, maxDisplaySelectedItems, value } = props.selectProps

  let otherItemsText
  if (isMulti && maxDisplaySelectedItems && value.length > maxDisplaySelectedItems) {
    const otherItemsCount = value.length - maxDisplaySelectedItems
    otherItemsText = t('common.multiSelectItemCount', { count: otherItemsCount })
  }
  const showOtherItemsStub = !!otherItemsText

  return (
    <StyledWrapper {...props} showOtherItemsStub={showOtherItemsStub}>
      {children}
      {showOtherItemsStub && <OtherItems>{otherItemsText}</OtherItems>}
    </StyledWrapper>
  )
}

ValueContainer.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.object,
}

export default ValueContainer
